var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 27,
    fill: "#EA1D26"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 25.8889C27.9041 25.8889 28.788 25.6282 29.5397 25.1399C30.2915 24.6515 30.8774 23.9574 31.2235 23.1453C31.5695 22.3331 31.66 21.4395 31.4836 20.5774C31.3072 19.7152 30.8718 18.9233 30.2325 18.3017C29.5932 17.6802 28.7786 17.2569 27.8918 17.0854C27.0051 16.9139 26.0859 17.0019 25.2506 17.3383C24.4153 17.6747 23.7013 18.2444 23.199 18.9752C22.6967 19.7061 22.4286 20.5654 22.4286 21.4444C22.4286 22.6232 22.9102 23.7536 23.7675 24.5871C24.6248 25.4206 25.7876 25.8889 27 25.8889ZM27 37C31.4183 37 35 35.01 35 32.5556C35 30.1011 31.4183 28.1111 27 28.1111C22.5817 28.1111 19 30.1011 19 32.5556C19 35.01 22.5817 37 27 37Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.82e998f504fcdbd5bc45fa47109f316f.svg";
export { ForwardRef as ReactComponent };